/*
 * Copyright (c) 2026. Bolmate B.V.
 *
 * Generic titled list group for the mobile card layouts: a centered pill label
 * (e.g. a date) above a stack of cards. Purely presentational — the caller
 * decides the grouping and renders the cards as children.
 */
import './style/bolmateListGroup.scss';

import React, {ReactNode} from 'react';

import classNames from 'classnames';

interface Props {
    /** Pill label shown centered above the group (e.g. "10 mei 2026"). */
    title: ReactNode;
    children: ReactNode;
    className?: string;
}

export default function BolmateListGroup(props: Props) {
    const {title, children, className} = props;

    return (
        <div className={classNames('bolmate-list-group', className)}>
            <div className='list-group-title-container'>
                <label className='list-group-title'>{title}</label>
            </div>
            <div className='list-group-items'>{children}</div>
        </div>
    );
}
